import { useCallback, useMemo, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { SupportChatContext } from './SupportChatContext';
import { SupportChatButton } from './SupportChatButton';

export function SupportChatProvider({ children }: { children: React.ReactNode }) {
  const [sectionsHideSupportChat, setSectionsHideSupportChat] = useState<string[]>([]);

  const setHideSupportChat = useCallback(
    (id: string, shouldHideSupportChat: boolean) => {
      setSectionsHideSupportChat((prev) => {
        if (shouldHideSupportChat) {
          return [...prev, id];
        }
        return prev.filter((sectionId) => sectionId !== id);
      });
    },
    [setSectionsHideSupportChat],
  );

  const isVisible = isEmpty(sectionsHideSupportChat);

  const value = useMemo(() => ({ isVisible, setHideSupportChat }), [isVisible, setHideSupportChat]);

  return (
    <SupportChatContext.Provider value={value}>
      <SupportChatButton />
      {children}
    </SupportChatContext.Provider>
  );
}
